import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4
              className="text-lg font-semibold mb-4 text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              苍井优
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              日本著名实力派女演员，以精湛演技和独特气质征服无数观众。从舞台剧到电影电视，她用多部经典作品证明了自己的实力。
            </p>
          </div>

          <div>
            <h4
              className="text-sm font-semibold mb-4 text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              作品分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/category/film"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                电影作品
              </Link>
              <Link
                to="/category/drama"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                电视剧
              </Link>
              <Link
                to="/category/stage"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                舞台剧
              </Link>
              <Link
                to="/category/awards"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                获奖经历
              </Link>
            </div>
          </div>

          <div>
            <h4
              className="text-sm font-semibold mb-4 text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              快捷链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/category/biography"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                个人资料
              </Link>
              <Link
                to="/category/news"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                最新动态
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4
              className="text-sm font-semibold mb-4 text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p>邮箱：contact@yuaoi-fans.com</p>
              <p>地址：日本东京都港区</p>
              <div className="flex items-center gap-4 mt-2">
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line"></i>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 苍井优中文资讯站. 本站为非官方粉丝信息网站，所有内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}